import React, { useState, useContext, useRef, useEffect, useCallback } from "react";
import { Spin, Input, Select, Form, message } from "antd";
import { LoadingOutlined } from "@/utils/antdIcon";
import { LoginFormContext } from "../../utils";
import { BackNav } from "../../comps";
import { CreateTeamAndEmployee, TeamUserInfo, UserTeamInfoInterface } from "@/types/LoginPage";
import { useTranslation } from "react-i18next";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { changeEgovUrl } from "@/utils/tools";
import { getWebEnvObj } from "@/utils";
import openCreateTeamSuccessModal from "./CreateTeamSuccess";
import _ from "lodash";
import styles from "../../index.module.less"
import "../../indexNew.less"

const { Option } = Select;
const {
  REACT_APP_OSS_BASE_URL = "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com"
} = getWebEnvObj();
enum CreateTeamStatus {
  Init, // 团队名称输入页面
  Finish // 加入完成页面
}
export interface createTeamParams {
  fullTeam: {
    teamSize: string; // 团队规模
    industry: string; // 行业类型
    shortName: string; // 团队名称
    province: string; // 省
    creatorName: string; // 创建者名称
    creatorId: string; // 创建者id
  };
}
export default function CreateTeam({ goBack, isLogin }: { goBack: () => void; isLogin: boolean }) {
  const { t } = useTranslation("common");
  const { service, onGlobalError, authInfo: authData, focusSDK } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const { authInfo: loginAuthInfo, enterApplication } = useContext(LoginFormContext);
  const authInfo = loginAuthInfo || authData;
  const [teamName, setTeamName] = useState<string | undefined>("");
  const [isValidate, setIsValidate] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [createStatus, setCreateStatus] = useState(CreateTeamStatus.Init);
  const teamsInfoRef = useRef<UserTeamInfoInterface | null>(null);
  const [allEnums, setAllEnums] = useState({
    industryTypeEnum: {
      "6": "制造业"
    },
    provinceEnum: {
      "110000": "北京市"
    },
    teamSizeEnum: {
      "1": "0-99"
    }
  });
  const [form] = Form.useForm();
  const doEnterApplication = useCallback(
    (content) => {
      let info: TeamUserInfo | null = null;
      const userInfo = _.pick(authData, [
        "mobile",
        "email",
        "hasPassword",
        "hasBindMobile",
        "hasBindEmail"
      ]);
      const teamInfoList =
        teamsInfoRef.current?.teamInfoList?.map((item) => {
          const data: TeamUserInfo = {
            ...item,
            ...userInfo
          };
          if (content.teamId === item.teamId) {
            info = data;
          }
          return data;
        }) || [];
      if (!info || !teamInfoList) {
        message.warning(t("createTeam.error"));
        return;
      }
      if (isLogin) {
        return enterApplication(info);
      } else {
        focusSDK.switchTeam(content.teamId, teamInfoList);
      }
    },
    [isLogin, enterApplication, authData]
  );
  useEffect(() => {
    service.focusService
      .getCreateTeamOptions({
        userId: authInfo.userId
      })
      .then((data: any) => {
        // console.log(data, "dataallEnums>ls");
        setAllEnums(data.allEnums);
      })
      .catch((e) => {
        console.log(e, "error");
      });
  }, [authInfo.userId]);
  const loadingComp = (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: "white" }} spin />} />
  );
  let teamCanCreated = true;
  function handleValuesChange(changedValues: any, allValues: any) {
    // if (v && v.length > 30) {
    //   return;
    // }
    // setTeamName(v);
    console.log(changedValues, allValues, "handleValuesChange");
    if (
      allValues.creatorName &&
      allValues.province &&
      allValues.teamSize &&
      allValues.industry &&
      allValues.shortName
    ) {
      setIsValidate(true);
      return;
    }
    setIsValidate(false);
  }

  const createTeam = () => {
    // setLoading(true);
    teamCanCreated = false;
    // const { authData } = config; // authData 中的teamUserInfo是已登录的team
    // 登录流程中的创建新团队 肯定还没有选择团队
    try {
      form.validateFields().then(async (values) => {
        console.log(values, "values");
        // @ts-ignore
        try {
          const content: CreateTeamAndEmployee = await service.focusService.createTeamAndEmployeeNew(
            {
              // @ts-ignore
              fullTeam: {
                creatorId: authInfo.userId,
                ...values
              }
            }
          );

          setLoading(true);
          teamCanCreated = true;
          if (content) {
            const teamsInfo = await service.focusService.getUserTeamInfo();

            teamsInfoRef.current = teamsInfo;
            openCreateTeamSuccessModal({
              info: content,
              isLogin,
              enterApplication: () => {
                doEnterApplication(content);
              }
            });
            // setNewTeamInfo(content);
          }
        } catch (e) {
          //  console.log(e, "e>ls");
          // onGlobalError(e);
          message.warning(e?.errorMsg || e?.msg || t("createTeam.error"));
        }
      });
    } catch (e) {
      // console.log(e, "e>ls");
      // onGlobalError(e);
    }
  };
  const getOptions = (itemsObject: any) => {
    const options: any[] = [];
    Object.keys(itemsObject).forEach((i) => {
      options.push(
        <Option key={i} value={i}>
          {itemsObject[i]}
        </Option>
      );
    });
    return options;
  };
  const teamInputForm = (
    <>
      <div style={{ marginBottom: -8 }}>
        <BackNav clickHandle={goBack} title={t("login.back")} subtitle={t("login.createTeam")} />
      </div>
      <div>
        <Form
          className="create-team-form"
          form={form}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          onValuesChange={handleValuesChange}
        >
          <Form.Item name="shortName" label={t("login.inputTeamName")}>
            <Input
              placeholder={t("login.inputTeamNamePlaceholder")}
              autoComplete="off"
              autoFocus
              allowClear
              maxLength={50}
            />
          </Form.Item>
          <Form.Item name="industry" label={t("login.inputTeamType")}>
            <Select placeholder={t("login.inputTeamTypePlaceholder")}>
              {getOptions(allEnums.industryTypeEnum)}
            </Select>
          </Form.Item>
          <Form.Item name="teamSize" label={t("login.inputTeamSize")}>
            <Select placeholder={t("login.inputTeamSizePlaceholder")}>
              {getOptions(allEnums.teamSizeEnum)}
            </Select>
          </Form.Item>
          <Form.Item name="province" label={t("login.inputTeamPlace")}>
            <Select placeholder={t("login.inputTeamPlacePlaceholder")}>
              {getOptions(allEnums.provinceEnum)}
            </Select>
          </Form.Item>
          <Form.Item name="creatorName" label={t("login.inputUserNameText")}>
            <Input
              placeholder={t("login.inputUserNameTextPlaceholder")}
              autoComplete="off"
              allowClear
              maxLength={50}
            />
          </Form.Item>
        </Form>
      </div>
      <div
        style={{
          position: "absolute",
          width: 320,
          bottom: 20
        }}
        className={styles["create-team-btn"]}
      >
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {
            if (!loading && isValidate) {
              createTeam();
            }
          }}
          className={styles.btn}
          style={
            !loading && isValidate
              ? {
                  opacity: 1,
                  cursor: "pointer"
                }
              : {
                background: "#BABFC5"
              }
          }
        >
          {loading && <div>{loadingComp}</div>}
          <div
            style={{
              margin: 12,
              fontSize: 14,
              color: "rgb(255, 255, 255)"
            }}
          >
            {t("nextStep")}
          </div>
        </div>
      </div>
    </>
  );

  //   const createFinish = (
  //     <div
  //       style={{
  //         textAlign: "center"
  //       }}
  //     >
  //       <img
  //         style={{
  //           width: 121,
  //           height: 111,
  //           marginBottom: 37
  //         }}
  //         src={changeEgovUrl(`${REACT_APP_OSS_BASE_URL}/statics/images/join-success.png`)}
  //         alt=""
  //       />
  //       <p
  //         style={{
  //           fontSize: 16,
  //           lineHeight: 1,
  //           margin: 0
  //         }}
  //       >
  //         {t("login.createSuccessAdmin")}
  //       </p>
  //       <a
  //         onClick={() => {
  //           // 废弃功能
  //           window.open("https://me.jdcloud.com");
  //         }}
  //       >
  //         https://me.jdcloud.com
  //       </a>
  //       <div
  //         className="btn secondary small"
  //         style={{
  //           margin: "57px auto 0 auto",
  //           cursor: "pointer"
  //         }}
  //         onClick={() => enterApplication(newTeamInfo)}
  //       >
  //         {t("login.enterApplication")}
  //       </div>
  //     </div>
  //   );
  return (
    <div className={styles.mobileForm}>
      {createStatus === CreateTeamStatus.Init ? teamInputForm : null}
      {/* {createStatus === CreateTeamStatus.Finish ? createFinish : null} */}
    </div>
  );
}
